"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
const DeleteOutlined_1 = __importDefault(require("@mui/icons-material/DeleteOutlined"));
const Save_1 = __importDefault(require("@mui/icons-material/Save"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const x_data_grid_1 = require("@mui/x-data-grid");
const x_data_grid_generator_1 = require("@mui/x-data-grid-generator");
function EditToolbar(props) {
    const { setRows, setRowModesModel } = props;
    const handleClick = () => {
        const id = (0, x_data_grid_generator_1.randomId)();
        setRows((oldRows) => [...oldRows, { id, testDate: '', english: '', math: '', reading: '', science: '', isNew: true }]);
        setRowModesModel((oldModel) => (Object.assign(Object.assign({}, oldModel), { [id]: { mode: x_data_grid_1.GridRowModes.Edit, fieldToFocus: 'testDate' } })));
    };
    return ((0, jsx_runtime_1.jsx)(x_data_grid_1.GridToolbarContainer, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ direction: 'row', justifyContent: 'space-between', alignItems: 'center', sx: { width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { children: "ACT" }), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: 1 }, startIcon: (0, jsx_runtime_1.jsx)(Add_1.default, {}), onClick: handleClick }, { children: "Add record" }))] })) }));
}
const DataGridACT = ({ act, handleActChange }) => {
    const [rows, setRows] = React.useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    React.useEffect(() => {
        setRows(act);
    }, []);
    React.useEffect(() => {
        handleActChange(rows);
    }, [rows]);
    const handleRowEditStop = (params, event) => {
        if (params.reason === x_data_grid_1.GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };
    const handleEditClick = (id) => () => {
        setRowModesModel(Object.assign(Object.assign({}, rowModesModel), { [id]: { mode: x_data_grid_1.GridRowModes.Edit } }));
    };
    const handleSaveClick = (id) => () => {
        setRowModesModel(Object.assign(Object.assign({}, rowModesModel), { [id]: { mode: x_data_grid_1.GridRowModes.View } }));
    };
    const handleDeleteClick = (id) => () => {
        setRows(rows.filter((row) => row.id !== id));
    };
    const handleCancelClick = (id) => () => {
        setRowModesModel(Object.assign(Object.assign({}, rowModesModel), { [id]: { mode: x_data_grid_1.GridRowModes.View, ignoreModifications: true } }));
        const editedRow = rows.find((row) => row.id === id);
        if (editedRow.isNew) {
            setRows(rows.filter((row) => row.id !== id));
        }
    };
    const processRowUpdate = (newRow) => {
        const updatedRow = Object.assign(Object.assign({}, newRow), { isNew: false });
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };
    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };
    const columns = [
        {
            field: 'testDate',
            headerName: 'Date',
            type: 'date',
            width: 180,
            flex: 1,
            editable: true,
        },
        {
            field: 'english',
            headerName: 'English Score',
            type: 'number',
            width: 200,
            flex: 1,
            align: 'right',
            headerAlign: 'left',
            editable: true,
        },
        {
            field: 'math',
            headerName: 'Math Score',
            type: 'number',
            width: 200,
            flex: 1,
            align: 'right',
            headerAlign: 'left',
            editable: true,
        },
        {
            field: 'reading',
            headerName: 'Reading Score',
            type: 'number',
            width: 200,
            flex: 1,
            align: 'right',
            headerAlign: 'left',
            editable: true,
        },
        {
            field: 'science',
            headerName: 'Science Score',
            type: 'number',
            width: 200,
            flex: 1,
            align: 'right',
            headerAlign: 'left',
            editable: true,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                var _a;
                const isInEditMode = ((_a = rowModesModel[id]) === null || _a === void 0 ? void 0 : _a.mode) === x_data_grid_1.GridRowModes.Edit;
                if (isInEditMode) {
                    return [
                        (0, jsx_runtime_1.jsx)(x_data_grid_1.GridActionsCellItem, { icon: (0, jsx_runtime_1.jsx)(Save_1.default, {}), label: 'Save', sx: {
                                color: 'primary.main',
                            }, onClick: handleSaveClick(id) }),
                        (0, jsx_runtime_1.jsx)(x_data_grid_1.GridActionsCellItem, { icon: (0, jsx_runtime_1.jsx)(Close_1.default, {}), label: 'Cancel', className: 'textPrimary', onClick: handleCancelClick(id), color: 'inherit' }),
                    ];
                }
                return [
                    (0, jsx_runtime_1.jsx)(x_data_grid_1.GridActionsCellItem, { icon: (0, jsx_runtime_1.jsx)(Edit_1.default, {}), label: 'Edit', className: 'textPrimary', onClick: handleEditClick(id), color: 'inherit' }),
                    (0, jsx_runtime_1.jsx)(x_data_grid_1.GridActionsCellItem, { icon: (0, jsx_runtime_1.jsx)(DeleteOutlined_1.default, {}), label: 'Delete', onClick: handleDeleteClick(id), color: 'inherit' }),
                ];
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)(Box_1.default, Object.assign({ sx: {
            height: '30vh',
            overflowY: 'auto',
            width: '100%',
            '& .actions': {
                color: 'text.secondary',
            },
            '& .textPrimary': {
                color: 'text.primary',
            },
        } }, { children: (0, jsx_runtime_1.jsx)(x_data_grid_1.DataGrid, { rows: rows, columns: columns, hideFooter: true, editMode: 'row', rowModesModel: rowModesModel, onRowModesModelChange: handleRowModesModelChange, onRowEditStop: handleRowEditStop, processRowUpdate: processRowUpdate, slots: {
                toolbar: EditToolbar,
            }, slotProps: {
                toolbar: { setRows, setRowModesModel },
            } }) })));
};
exports.default = DataGridACT;
